import { Route, Routes } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import Academy from "../container/academy/home";
import AcademyCourses from "../container/academy/courses";
import AcademyLiveStream from "../container/academy/livestream";
import AcademyNews from "../container/academy/news";
import AcademyComics from "../container/academy/comics";
import AcademyCourse from "../container/academy/courses/Course";
import AcademyModule from "../container/academy/courses/Module";
import AcademyLiveStreamPlayer from "../container/academy/livestream/Livestream";
import AcademyWrapper from "../layout/academy-wrapper";

const AcademyRoutes = () => {
    return (
        <Routes>
            <Route element={<AcademyWrapper />}>
                <Route index element={<Academy />} />
                <Route path={ROUTES.COURSES} element={<AcademyCourses />} />
                <Route path={ROUTES.COURSE} element={<AcademyCourse />} />
                <Route path={ROUTES.MODULE} element={<AcademyModule />} />
                <Route path={ROUTES.LIVESTREAM} element={<AcademyLiveStream />} />
                <Route path={ROUTES.LIVESTREAM_PLAYER} element={<AcademyLiveStreamPlayer />} />
                <Route path={ROUTES.NEWS} element={<AcademyNews />} />
                <Route path={ROUTES.COMICS} element={<AcademyComics />} />
            </Route> 
        </Routes>
    );
}

export default AcademyRoutes
